import { Injectable } from '@angular/core';
import { IS1SearchParams, IS1TypedPaginatedResult, S1ApiCrudService, S1HttpClientService } from '@app/s1';
import { ICassa } from '../models/cassa';
import { Observable } from 'rxjs';

export interface IRicercaCassaParams extends IS1SearchParams, Partial<ICassa> { 
  idStazione?: string 
}

@Injectable({
  providedIn: 'root'
})
export class CassaService extends S1ApiCrudService<ICassa, IRicercaCassaParams> {

  set idPath(newValue: string) {
    this.path = `/stazione/${newValue}/cassa`;
  }

  constructor(s1HttpClient: S1HttpClientService) { 
    super(s1HttpClient, ""); // Path will be setted by set idPath
  }

  ricercaCasse(params: IRicercaCassaParams, path?: string): Observable<IS1TypedPaginatedResult<ICassa>> {
    return super.ricerca(params, "/stazione/cassa")
  }

}
